import {
  Component, ComponentRef, HostBinding, ViewChild, ViewContainerRef,
} from "@angular/core";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {OptionService} from "../../services/option/option.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {PitchHelpPopupComponent} from "./pitch-help-popup.component";


@Component({
  selector: 'app-pitch-help-btn',
  template: `
    <button #container
            type="button"
            class="help-btn"
            (click)="onClick($event)">도움말
    </button>
  `,
  styleUrls: ['./pitch-help-btn.component.scss']
})
export class PitchHelpBtnComponent {
  // @HostBinding('class') class = 'help-btn-box';
  @HostBinding('style.display') styleBlock = 'block';
  @ViewChild('container', {read: ViewContainerRef}) container?: ViewContainerRef;
  private componentRef: ComponentRef<PitchHelpPopupComponent> | null = null;

  constructor(
    private dynamicSvc: DynamicComponentService,
    private optionSvc: OptionService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    if (!this.container === null) {
      throw new Error(`WordHelpBtnComponent::ngOnInit() container is null`);
    }

    if (this.componentRef) {
      this.closePopup();
    } else {
      this.componentRef = this.dynamicSvc.createComponent(PitchHelpPopupComponent, this.container);
      this.componentRef.instance.close.subscribe((showSaseung: boolean | null) => {
        // console.log('WordHelpBtnComponent::ngAfterViewInit() close.subscribe()', showSaseung);

        if (showSaseung !== null) {
          this.optionSvc.showSaseung = showSaseung;
        }

        this.closePopup();
      });
    }
  }

  private closePopup() {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
